/* eslint-disable react/destructuring-assignment */
import { Button, Grid, Group, MultiSelect, Paper, Select, SimpleGrid, Space } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconBuilding, IconClearAll, IconSearch } from '@tabler/icons-react';
import EntityPicker from '../../../../../components/core/EntityPicker/EntityPicker';
import useCurrentUser from '../../../../../hooks/useCurrentUser';
import { CompanyType, EntityTypeType, ProposalStatusType } from '../../../../../models/core/cache.type';
import { EntitySearchResponseType } from '../../../../../models/core/entities.type';

type FilterData = {
  idEmpresa: string | null;

  entidadeData: EntitySearchResponseType | null;
  idEntidade: number | null;
  entidade: string;

  listaStatus: string[];
};

type FilterProps = {
  companies: CompanyType[];
  entityTypeData: EntityTypeType[];
  proposalStatuses: ProposalStatusType[];
  filter(data: FilterData): void;
  clear(): void;
  loading: boolean;
  zIndex: number;
};

function Filter(props: FilterProps) {
  const [currentUser] = useCurrentUser();

  const form = useForm<FilterData>({
    initialValues: {
      idEmpresa: currentUser.executivo ? null : currentUser.idEmpresa.toString(),

      entidadeData: null,
      idEntidade: null,
      entidade: '',

      listaStatus: [],
    },
  });

  return (
    <form onSubmit={form.onSubmit(props.filter)}>
      <Paper shadow="xs" p="md" withBorder>
        <Grid columns={7}>
          <Grid.Col span={1}>
            <Select
              leftSection={<IconBuilding size={15} />}
              label="Empresa"
              description="Filtro: igual"
              placeholder="Todos..."
              data={props.companies.map((x) => {
                return {
                  value: x.idEmpresa.toString(),
                  label: x.empresa,
                };
              })}
              searchable
              clearable={currentUser.executivo}
              disabled={!currentUser.executivo}
              {...form.getInputProps('idEmpresa')}
            />
          </Grid.Col>
          <Grid.Col span={2}>
            <EntityPicker
              label="Entidade"
              description="Filtro: igual"
              formItem={form.getInputProps('idEntidade')}
              required={false}
              idsToBeDisabled={[]}
              disabled={false}
              callback={(item: EntitySearchResponseType | EntitySearchResponseType[] | null) => {
                if (!Array.isArray(item) && item) {
                  form.setFieldValue('entidadeData', item);
                  form.setFieldValue('idEntidade', item.idEntidade);
                  form.setFieldValue('entidade', item.nomeFantasia || item.razaoSocial || item.nome || '');
                }
              }}
              zIndex={props.zIndex + 1}
              useCache
              allowMultiple={false}
              query={undefined}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <MultiSelect
              label="Status"
              description="Filtro: igual"
              placeholder="Todos..."
              data={props.proposalStatuses.map((x) => {
                return {
                  value: x.codigoPropostaStatus,
                  label: x.propostaStatus,
                };
              })}
              clearable
              {...form.getInputProps('listaStatus')}
            />
          </Grid.Col>
        </Grid>
        <Space h="md" />

        <SimpleGrid cols={1}>
          <Group>
            <Button
              color="secondary"
              leftSection={<IconClearAll size={18} />}
              disabled={props.loading}
              onClick={() => {
                form.reset();
                props.clear();
              }}
            >
              Limpar
            </Button>
            <Button leftSection={<IconSearch size={18} />} type="submit" loading={props.loading}>
              Pesquisar
            </Button>
          </Group>
        </SimpleGrid>
      </Paper>
      <Space h="xl" />
    </form>
  );
}

export { Filter };
export type { FilterData };
